module.exports = __webpack_public_path__ + "img/kg.ead22e65.svg";